import { FunctionComponent, useMemo } from 'react'
import { marked } from 'marked'
import styled from 'styled-components'
import CustomHTMLBlock from '../CustomHTMLBlock/CustomHTMLBlock'

interface MarkdownProps {
  children: string
}

const StyledCustomHTMLBlock = styled(CustomHTMLBlock)`
  h1 {
    margin-bottom: 1.25rem;
    font-size: 1.5rem;
    line-height: 1.25;

    @media screen and (min-width: 64rem) {
      font-size: 1.875rem;
    }
  }

  h2 {
    font-size: 1.25rem;
    line-height: 1.25;

    @media screen and (min-width: 64rem) {
      font-size: 1.5rem;
    }
  }

  p,
  ul li,
  ol li,
  p a {
    font-size: 1rem;
    line-height: 1.375;

    @media screen and (min-width: 64rem) {
      font-size: 1.125rem;
      line-height: 1.4;
    }
  }

  li > p {
    display: inline;
  }
`

const MarkdownParser: FunctionComponent<MarkdownProps> = ({ children }) => {
  const formattedContent = useMemo(() => marked(children), [children])

  return <StyledCustomHTMLBlock body={formattedContent as string} />
}

export default MarkdownParser
